import React, { forwardRef } from 'react';
import { cn } from 'utils';

const Card = forwardRef((props, ref) => {
  const { className, ...rest } = props;
  return (
    <div
      ref={ref}
      className={cn(
        'bg-card text-card-foreground dark:border-black-100 rounded-lg border bg-white shadow-sm dark:border-none dark:bg-inherit',
        className
      )}
      {...rest}
    />
  );
});
Card.displayName = 'Card';

const CardHeader = forwardRef((props, ref) => {
  const { className, ...rest } = props;
  return (
    <div
      ref={ref}
      className={cn('flex flex-col space-y-1.5 p-6', className)}
      {...rest}
    />
  );
});
CardHeader.displayName = 'CardHeader';

const CardTitle = forwardRef((props, _ref) => {
  const { className: _className, ...rest } = props;
  return (
    <h2
      className="truncate text-base font-medium tracking-wide text-gray-800 dark:text-dark-100"
      {...rest}
    />
  );
});
CardTitle.displayName = 'CardTitle';

const CardDescription = forwardRef((props, ref) => {
  const { className, ...rest } = props;
  return (
    <div
      ref={ref}
      className={cn('text-muted-foreground text-sm', className)}
      {...rest}
    />
  );
});
CardDescription.displayName = 'CardDescription';

const CardContent = forwardRef((props, ref) => {
  const { className, ...rest } = props;
  return <div ref={ref} className={cn('p-6 pt-0', className)} {...rest} />;
});
CardContent.displayName = 'CardContent';

const CardFooter = forwardRef((props, ref) => {
  const { className, ...rest } = props;
  return (
    <div
      ref={ref}
      className={cn('flex items-center p-6 pt-0', className)}
      {...rest}
    />
  );
});
CardFooter.displayName = 'CardFooter';

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardDescription,
  CardContent,
};
